import { render, staticRenderFns } from "./AvatarWithInfo.vue?vue&type=template&id=3b3d8011&"
import script from "./AvatarWithInfo.vue?vue&type=script&lang=js&"
export * from "./AvatarWithInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AvatarImage: require('/opt/buildhome/repo/components/global/Avatar/AvatarImage.vue').default})
